import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import { AiOutlineDownload, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// Importing local PDF from Assets folder
import pdfFile from "../../Assets/CV_Latest.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setWidth(window.innerWidth);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const previousPage = () => {
    if (pageNumber > 1) {
      setPageNumber((prev) => prev - 1);
    }
  };

  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber((prev) => prev + 1);
    }
  };

  // Adjust scale dynamically so it fills the screen without overflowing
  const pdfScale = width > 786 ? (width > 1200 ? 1.5 : 1.2) : 0.6;

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />

        {/* Top Download Button */}
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdfFile}
            target="_blank"
            download="CV_Latest.pdf"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        {/* Smooth Horizontal Slide Container */}
        <Row className="resume my-4 d-flex justify-content-center">
          <div
            style={{
              overflow: "hidden",
              width: "100%",
              maxWidth: "1000px",
              margin: "0 auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Document
              file={pdfFile}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={<div style={{ color: "white", minHeight: "600px" }}>Loading PDF...</div>}
            >
              <div
                style={{
                  display: "flex",
                  transform: `translateX(-${(pageNumber - 1) * 100}%)`,
                  transition: "transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)",
                  width: "100%",
                }}
              >
                {numPages &&
                  Array.from(new Array(numPages), (el, index) => (
                    <div
                      key={`page_${index + 1}`}
                      style={{
                        minWidth: "100%",
                        boxSizing: "border-box",
                        display: "flex",
                        justifyContent: "center",
                        padding: "0 10px",
                      }}
                    >
                      <Page
                        pageNumber={index + 1}
                        scale={pdfScale}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </div>
                  ))}
              </div>
            </Document>
          </div>
        </Row>

        {/* Bottom Navigation & Download Bar */}
        <Row className="justify-content-center my-3" style={{ position: "relative" }}>
          <div className="d-flex align-items-center justify-content-center flex-wrap gap-2">
            <Button
              variant="primary"
              onClick={previousPage}
              disabled={pageNumber <= 1}
              style={{ minWidth: "110px" }}
            >
              <AiOutlineLeft /> Previous
            </Button>

            <span
              style={{
                color: "white",
                padding: "0 12px",
                fontWeight: "bold",
                fontSize: "1.1rem",
                whiteSpace: "nowrap",
              }}
            >
              Page {pageNumber} of {numPages || "--"}
            </span>

            <Button
              variant="primary"
              onClick={nextPage}
              disabled={pageNumber >= numPages}
              style={{ minWidth: "110px" }}
            >
              Next <AiOutlineRight />
            </Button>

            <Button
              variant="primary"
              href={pdfFile}
              target="_blank"
              download="CV_Latest.pdf"
              style={{ maxWidth: "250px", marginLeft: "10px" }}
            >
              <AiOutlineDownload />
              &nbsp;Download CV
            </Button>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;